import { apiGet, apiPost } from './api';

export interface EmployeeChatMessage {
  botId: number;
  content: string;
}

export interface TaskDetail {
  seq: number;
  botId: number;
  botName: string | null;
  content: string;
  status: string;
  sentTime: string | null;
  errorMsg: string | null;
}

export interface TaskInfo {
  taskId: string;
  status: string;
  totalCount: number;
  sentCount: number;
  failedCount: number;
  details: TaskDetail[];
}

export async function sendEmployeeChat(roomId: number, messages: EmployeeChatMessage[]): Promise<{ taskId: string; totalCount: number }> {
  const res = await apiPost<{ code: number; data: { taskId: string; totalCount: number }; msg?: string }>(
    '/api/employee-chat/send', { roomId, messages }
  );
  if (res.code !== 0) throw new Error(res.msg || '发送失败');
  return res.data;
}

export async function getEmployeeChatTaskStatus(taskId: string): Promise<TaskInfo> {
  const res = await apiGet<{ code: number; data: TaskInfo; msg?: string }>(`/api/employee-chat/task/${taskId}`);
  if (res.code !== 0) throw new Error(res.msg || '查询失败');
  return res.data;
}
